"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "minorScale", {
  enumerable: true,
  get: function get() {
    return _minorScale.default;
  }
});
Object.defineProperty(exports, "majorScale", {
  enumerable: true,
  get: function get() {
    return _majorScale.default;
  }
});

var _minorScale = _interopRequireDefault(require("./src/minorScale"));

var _majorScale = _interopRequireDefault(require("./src/majorScale"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zY2FsZXMvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgYXMgbWlub3JTY2FsZSB9IGZyb20gJy4vc3JjL21pbm9yU2NhbGUnXG5leHBvcnQgeyBkZWZhdWx0IGFzIG1ham9yU2NhbGUgfSBmcm9tICcuL3NyYy9tYWpvclNjYWxlJ1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/scales/index.js
// module id = 57
// module chunks = 0